import { useTranslation } from 'react-i18next';
import styles from './ErrorState.module.css';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export const ErrorState = ({ title, message, onRetry }: ErrorStateProps) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('common:loadError');
  const resolvedMessage = message ?? t('common:networkError');

  return (
    <div className={styles.container} role="alert">
      <h2 className={styles.title}>{resolvedTitle}</h2>
      <p className={styles.message}>{resolvedMessage}</p>
      {onRetry && (
        <button type="button" className={styles.retryButton} onClick={onRetry}>
          {t('common:retry')}
        </button>
      )}
    </div>
  );
};
